<div class="crc-main-outer-card" *ngIf="crcData">
  <div class="title-head-main">
    <h1 class="main-tit-outer">CRIF Details</h1>
  </div>

  <div class="crc-container-root">
    <div class="crc-simple-card" *ngFor="let crc of crcData; let i = index">
      <div class="title-head-sub">
        <h1 class="sub-tit">{{ crc["Value"] || 'Record #' + (i + 1) }}</h1>
      </div>
      
      <div class="ctn-data" style="padding: 10px;">
        <div class="main-cont">
          <h1 class="Text-Head">CreditVision Score:</h1>
          <div class="text-content ml-2" style="display: inline;">{{ crc["CRC_CreditVisionScore"] || '0' }}</div>
        </div>

        <div class="main-cont">
          <h1 class="Text-Head">Personal Loan Score:</h1>
          <div class="text-content ml-2" style="display: inline;">{{ crc["CRC_PersonalLoanScore"] || '0' }}</div>
        </div>

        <div class="main-cont">
          <h1 class="Text-Head">Total A/C:</h1>
          <div class="text-content ml-2" style="display: inline;">{{ crc["CRC_TotalAccounts"] || '0' }}</div>
        </div>

        <div class="main-cont">
          <h1 class="Text-Head">Current Balance:</h1>
          <div class="text-content ml-2" style="display: inline;">{{ crc["CRC_CurrentBalanceAmount"] || '0' }}</div>
        </div>
        
        <div class="main-cont">
          <h1 class="Text-Head">OverDue A/c:</h1>
          <div class="text-content ml-2" style="display: inline;">{{ crc["CRC_OverDueAccounts"] || '0' }}</div>
        </div>

        <div class="main-cont">
          <h1 class="Text-Head">OverDue Amount:</h1>
          <div class="text-content ml-2" style="display: inline;">{{ crc["CRC_OverDueAmount"] || '0' }}</div>
        </div>

        <div class="main-cont">
          <h1 class="Text-Head">Attachment:</h1>
          <div class="text-content ml-2" style="display: flex; gap: 8px; align-items: center;">
            <a target="_blank" *ngIf="crc.isView != 1 && crc.isViewSurepass != 1 && crc.isViewexperianSurepass != 1 && crc.isViewCrifApi != 1" href="{{crcAttachement}}/{{crc.CRC_ReportName}}"> 
              <i class="fa fa-paperclip" style="font-size: 16px;"></i>
            </a>

            <a *ngIf="crc.isView == 1" (click)="getCRCThirdDetail(crc)">
              <i class="fa fa-link" style="font-size: 16px; cursor: pointer;"></i>
            </a>
            <a *ngIf="crc.isViewSurepass == 1" (click)="getCRCThirdSurePassDetail(crc)">
              <i class="fa fa-link" style="font-size: 16px; cursor: pointer;"></i>
            </a>
            <a *ngIf="crc.isViewexperianSurepass == 1" (click)="getCRCThirdexperianSurepassDetail(crc)">
              <i class="fa fa-link" style="font-size: 16px; cursor: pointer;"></i>
            </a>
            <a *ngIf="crc.isViewCrifApi == 1" href="{{crcAttachement}}/{{crc.CRC_ReportName}}" target="_blank">
              <i class="fa fa-paperclip" style="font-size: 16px;"></i>
            </a>
            
            <a *ngIf="!!crc.CRC_ReportName1" target="_blank" href="{{crcAttachement}}/{{crc.CRC_ReportName1}}"> 
              <i class="fa fa-paperclip" style="font-size: 16px;"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!crcData || crcData.length === 0" class="text-center p-4">
  No Information Available!!
</div>



<div class="modal fade in"
     id="cibilReportmain{{ index }}"
     tabindex="-1"
     role="dialog"
     aria-labelledby="myModalLabel"
     data-backdrop="false"
     style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Cibil Report
        </h6>

        <button type="button"
                (click)="onCloseCibilmainReport()"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>

      <div class="modal-body" style="font-size: 10px">
        <ng-container *ngIf="cibilResponseMain">
          <app-quickloan-cibil-report [cibilResponse]="cibilResponseMain">
          </app-quickloan-cibil-report>
        </ng-container>
      </div>
    </div>
  </div>
</div>



<div class="modal fade in"
     id="experianReport{{ index }}"
     tabindex="-1"
     role="dialog"
     aria-labelledby="myModalLabel"
     data-backdrop="false"
     style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Experian Report
        </h6>
        <button type="button"
                (click)="onCloseExperianReportModel()"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body" style="font-size: 10px">
        <ng-container *ngIf="experianResponse">
          <app-quickloan-experian-report [experianResponse]="experianResponse">
          </app-quickloan-experian-report>
        </ng-container>
        
      </div>
    </div>
  </div>
</div>



<div class="modal fade in"
     id="cibilReportSurePass{{ index }}"
     tabindex="-1"
     role="dialog"
     aria-labelledby="myModalLabel"
     data-backdrop="false"
     style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Cibil Report
        </h6>
        <button type="button"
                (click)="onClosecibilReportSurePass()"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body" style="font-size: 10px">
        <ng-container *ngIf="cibilResponseSurePass">
          <app-quickloan-cibil-surepass [cibilResponseSurePass]="cibilResponseSurePass">
          </app-quickloan-cibil-surepass>
        </ng-container>
        
      </div>
    </div>
  </div>
</div>
